import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import {MutationCreateRegionArgs, MutationUpdateRegionArgs, QueryRegionsArgs} from "@irati/types/ops"
import {Region} from "@irati/types"
import PBService from "@irati/utils/services"

import listFormat from "@irati/utils/services/graph/utils/listFormat"
import regionQuery, {regionKey} from "./queries/getRegion"
import allRegionListQuery, {allRegionsKey} from "./queries/getAllRegions"
import createRegion, {createRegionKey} from "./mutations/createRegion"
import updateRegion, {updateRegionKey} from "./mutations/updateRegion"
import listRegionsQuery, {regionsKey} from "./queries/listRegions"

class RegionDataService extends PBService {
  getRegion = (id: string, options: QueryOptions = {}): Promise<Region> => {
    const variables = {id}
    return client.query({...options, query: regionQuery, variables}).then(({data}) => {
      return data[regionKey]
    })
  }

  getAllRegions = (options: QueryOptions = {}): Promise<Region[]> => {
    return client.query({...options, query: allRegionListQuery}).then(({data}) => {
      return data[allRegionsKey]?.results
    })
  }

  createRegion(variables: MutationCreateRegionArgs, options: MutationOptions = {}): Promise<Region> {
    return client.mutate({...options, mutation: createRegion, variables}).then(({data: responseData}) => {
      return responseData[createRegionKey]
    })
  }

  updateRegion(variables: MutationUpdateRegionArgs, options: MutationOptions = {}): Promise<Region> {
    return client.mutate({...options, mutation: updateRegion, variables}).then(({data: responseData}) => {
      return responseData[updateRegionKey]
    })
  }

  list(variables: QueryRegionsArgs, options: QueryOptions = {}) {
    return client.query({...options, query: listRegionsQuery, variables}).then(({data}) => {
      return listFormat<Region>(data[regionsKey])
    })
  }
}

const regionDataService = new RegionDataService({errorHandlers: []})
export default regionDataService
